import { render } from "./Photography.vue?vue&type=template&id=c9fa7f54&scoped=true"
import script from "./Photography.vue?vue&type=script&lang=js"
export * from "./Photography.vue?vue&type=script&lang=js"

import "./Photography.vue?vue&type=style&index=0&id=c9fa7f54&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9fa7f54"]])

export default __exports__